import { IconError404 } from '@tabler/icons-react'
import Link from 'next/link'

import { routes } from '../utils'

import { CorePage } from '@/components/layout-components/CorePage'
import { Button } from '@/components/shared-components/BUI/Button'
import { Text } from '@/components/shared-components/BUI/Text'
import { ErrorIcon } from '@/components/shared-components/ErrorIcon'
import { Flexbox } from '@/components/shared-components/Flexbox'
import { openLiveChatToNewConversation } from '@/components/util-components/live-chat/LiveChat'
import { useSetBreadcrumbs } from '@/context/breadcrumbContext'
import { useRouterParams } from '@/hooks/useRouterParams'

export type Four0hFourParams = {
  resource?: string
  backUrl?: string
}

const FourOhFour = () => {
  const { resource, backUrl } = useRouterParams<Four0hFourParams>({
    resource: 'page',
  })

  useSetBreadcrumbs([{ text: 'Unknown ' + resource, icon: IconError404 }])

  return (
    <CorePage easyPadding>
      <Flexbox flexDirection="column" gap="1rem" alignItems="center" mt="2rem">
        <ErrorIcon />
        <Text variant="subheading01" strong>
          404
        </Text>
        <Text variant="label01" mb="2rem">
          Sorry, the {resource} you visited does not exist
        </Text>

        <Link href={backUrl ?? routes.home()}>
          <Button variant="primary">Go back {backUrl ? '' : 'home'}</Button>
        </Link>

        <Button
          onClick={openLiveChatToNewConversation}
          variant="secondary-text"
        >
          Talk to BuildPass support
        </Button>
      </Flexbox>
    </CorePage>
  )
}

export default FourOhFour
